module.exports = __webpack_public_path__ + "img/moliere.972378c8.jpg";